import * as React from 'react';
import { Carousel } from 'react-bootstrap';
import Radium, { StyleRoot } from 'radium';
import * as Tgcc from '../tgccGlobal';
import {BaseProps, Merchandising, MerchandisingTheme, Product, Design, GlobalState} from '../tgccGlobal';
import {connect} from 'react-redux';
import {CSSProperties} from 'react';
import * as Request from '../tgccRequest';
import { CampusFooter } from './CampusFooter';
import {browserHistory} from 'react-router';
import {CampusDesignCard} from '../DesignSelector/CampusDesignCard';
import {ScreenDoor} from '../Components/ScreenDoor';
import {CloseX} from '../Components/CloseX';
import { CampusHeader } from './CampusHeader';




declare var AssetRoot: string;

const imageStyle: CSSProperties = {
    margin: 'auto',
    cursor: 'pointer',
    width:'341px',
    transition:'transform 250ms',
    ':hover': {
        border: '2px solid #E9E6E6',
        transform:'translateY(-10px)'
    }
}
const mobileImageStyle: CSSProperties ={
    height:'335px',
    cursor:'pointer'
}
const imgContainer: CSSProperties = {
    textAlign:'center'
}
const merchHdr: CSSProperties = {
    display:'flex',
    flexDirection:'column',
    justifyContent:'center'
}
const collectDiv: CSSProperties = {
    display:'flex',
    flexWrap:'wrap',
    width:'1200px',
    marginTop:'3%'
}
const container: CSSProperties = {
    display:'flex',
    width:'100%',
    justifyContent:'center'
}
const designCont: CSSProperties = {
    display:'flex',
    width:'100%',
    justifyContent:'center',
    marginTop:'3%'
}
const inDesignCont: CSSProperties = {
    display:'flex',
    flexWrap:'wrap',
    justifyContent:'center'
}
const addToProofBtn: CSSProperties = {
    border: '1px solid transparent',
    backgroundColor: '#D7D7D7',
    height: '35px',
    lineHeight: '35px',
    fontSize: '15px',
    padding: '0 25px',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: '#626262',
    alignSelf: 'center',
    cursor: 'pointer',
    margin: '10px 0',
    fontFamily:'BarlowMedium'
}
const titleStyle: CSSProperties = {
    display:'flex',
    justifyContent:'center',
    color:'#303030',
    fontFamily:'Lulo',
    textTransform:'uppercase',
    fontSize:'34px',
    marginTop:'2%'
}
const textStyle: CSSProperties = {
    color:'#303030',
    fontFamily:'BarlowLight',
    display:'flex',
    justifyContent:'center',
    fontSize:'15px'

}
const mobileDiv: CSSProperties = {
    display:'flex',
    flexDirection:'column',
    alignItems:'center'
}
const DIVISION: string = 'Campus';

class _Collection extends React.Component<BaseProps, any>{
    state  = { 
        items: Tgcc.Merchandising[0],
        theme: new Tgcc.MerchandisingTheme,
        product: Product,
        design: Design,
        Designs:null,
        isWaiting: true,
        zoomDesign:null
    };

    componentWillMount(){
        var division = this.props.params.division;
        var theme = this.props.params.theme;
        if(theme){
            Request.getMerchandisingTheme(division, theme, this.onThemeLoaded);
            Request.getMerchandising(division, theme, this.onMerchandisingLoaded);
            Request.getDesignsFiltered(DIVISION, theme.toLowerCase(), (Designs : Tgcc.Design[]) => this.DesignsLoaded(Designs));
        }
        Request.getMerchandising(division, theme, this.onMerchandisingLoaded);

    }
    componentDidMount(){
        var tag = document.getElementById('collect');
        tag.scrollIntoView(true);
    }
    
    openSchools = () => {browserHistory.replace(Tgcc.Routes.CampusDesignListView)};

    onMerchandisingLoaded = (items: Tgcc.MerchBinding[]) => {
        this.setState({items: items});
    }

    onThemeLoaded = (theme: MerchandisingTheme) => {
        this.setState({theme: theme});
    }

    createItem= (item: Tgcc.MerchBinding) => {
        var merch = item.merchandising;
        return <img key={merch.assetId} onClick={() => this.select(item)} style={imageStyle} src={Tgcc.getMerchImagePath(merch.imageName)}/>

    }
    DesignsLoaded(Designs : Tgcc.Design[]) {
        for(var i in Designs)
            Designs[i].displayIndex = Number(i);
        this.setState({Designs: Designs,isWaiting:false});
    }
    handleZoom = (design: Tgcc.Design) => {
        this.setState({zoomDesign:design});
    }

    handleDesignSelection = (design : Tgcc.Design) => {
        this.props.dispatch({type: Tgcc.StateAction.DesignFromReal, payload: design});
    }
    DesignsVisible: boolean = false;
    getDesignItems() {
        this.DesignsVisible = false;
       
        var Designs = new Array();
        var noItemsStyle = { fontFamily: 'CenturyGothic', fontSize:'24px', textAlign: 'center', width: '100%', textTransform: 'uppercase', alignSelf: 'center'};

        if(this.state.Designs){
            if(this.state.Designs.length == 0){
                Designs.push( <div key="none" style={noItemsStyle}>No matching items</div>);
            } 

            for(var i in this.state.Designs){
                var design: Tgcc.Design = this.state.Designs[i];
                Designs.push(<CampusDesignCard key={design.id} design={design} onSelect={this.handleDesignSelection} onZoom={this.handleZoom}/>);
            }
            this.DesignsVisible = true;
        } else {
            var chooseSomething = (<div key="none" style={noItemsStyle}>Select a category or search</div>);
            Designs.push(chooseSomething);
        }

        return Designs;
        
    }
    getItems = () => {
        var items = new Array();
        if(this.state.items){
            this.state.items.forEach(item => {
                items.push(this.createItem(item));
            });
        }
        return items;
    }
    createMobileItem= (item: Tgcc.MerchBinding) => {
        var merch = item.merchandising;
        return  <div key={merch.assetId} onClick={() => this.select(item)}>
                    <img key={merch.assetId} style={mobileImageStyle} src={Tgcc.getMerchImagePath(merch.imageName)}/>
                </div>
    }
    getMobileItems = () => {
        var items = new Array();
        if(this.state.items){
            this.state.items.forEach(item =>{
                items.push(this.createMobileItem(item));
            })
        }
        return items;
    }

    getTheme = () => {
         return (
            <div style={merchHdr} className="campusCollectView">
                <img src={AssetRoot + 'merchlogos/' +this.state.theme.bannerImage}/>
           </div>
         )

    }
    select = (item: Tgcc.MerchBinding) =>{
        if(this.props.params.division && this.props.params.division.toLowerCase() == 'collegiate')
            item.editRoute = Tgcc.Routes.CampusProofEdit;
        else
            item.editRoute = Tgcc.Routes.CampusProofEdit;

        this.props.dispatch({type: Tgcc.StateAction.ProofFromMerch, payload: item});
    }
    getComponent(){
        if(window.innerWidth <= 440){
            return <div style={mobileDiv}>{this.getMobileItems()}</div>
        }
           return <div style={container}>
                    <div style={collectDiv}>
                    {this.getItems()}
                    </div>
                </div>
    }

    render(){
        var designs = this.state.isWaiting ? <Tgcc.LoadingElement /> : this.getDesignItems() 
        return (
            <div id="collect">
                <CampusHeader />
                {this.getTheme()}

                <div style={titleStyle} className="realCollHdr">Choose a Design</div>
                <div style={textStyle}>See what we're doing on your campus!</div>
                <div style={textStyle}>Click ANY design from the {this.state.theme.title} Gallery for your own order</div>
                <div style={designCont}>
                        <div style={inDesignCont}>
                            {designs}
                        </div>
                        {this.getZoomedDesign()}

                </div>
                <CampusFooter state={this.props.state} />
            </div>
        )
    }
    getZoomedDesign = () =>  {
        if(!this.state.zoomDesign)
            return (<a/>);

       let fullSizeStyle: CSSProperties = {
            position: 'relative',
            background: 'white',
            border: Tgcc.Styles.singleBorder,
            boxShadow: Tgcc.Styles.boxShadow,
            padding: '20px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignContent: 'center',
            alignSelf: 'center',
            width: '600px',
            height: '800px',
            maxWidth: '90%',
            maxHeight: '75%',
            '@media (max-width:768px) and (max-height:1024px)': {
                margin:'30px auto'
            }
           
       };

        let imgStyle: CSSProperties = {
            width: 'auto',
            height: 'auto',
            maxWidth: '80%',
            maxHeight: '75%',
            display: 'block',
            alignSelf: 'center',
            cursor: 'zoom-out'
        };

        let screenDoor: CSSProperties = {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 99,
            backgroundColor: 'rgba(22,22,22,0.5)',
            justifyContent: 'center',
            alignContent: 'center',
            display: 'flex',
            flexDirection: 'column',
            overflowY: 'auto',
            overflowX: 'hidden'
        }        
        let footerStyle: CSSProperties ={
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            width: '100%',
            marginTop: '10px'
        }
        let arrowStyle: CSSProperties = {
            cursor: 'pointer',
            fontSize: '70px',
            height: '40px',
            lineHeight: '30px',
            color: 'darkgray',
            display: 'flex',
            alignSelf: 'center'
        }
        var largeImage = Tgcc.getDesignPath(this.state.zoomDesign.image);
        return ( 
            <ScreenDoor>
                <div style={fullSizeStyle} className="fullSizeStyle">
                    <CloseX closeAction={this.hideZoom} />
                    <img src={largeImage} style={imgStyle} onError={Tgcc.handleDesignImageError} onClick={this.hideZoom}/> 
                    <div style={footerStyle}>
                        <div style={arrowStyle} onClick={this.handlePrev}>&lsaquo;</div>
                        <div className="grayButton" style={addToProofBtn} onClick={this.handleZoomAdd}>add to proof</div>
                        <div style={arrowStyle} onClick={this.handleNext}>&rsaquo;</div>
                    </div>  
                </div>
            </ScreenDoor>
        )
    }
    hideZoom = () => {
        this.setState({zoomDesign: null});
    }
    handleZoomAdd = (evt: React.MouseEvent<HTMLDivElement>) => {
        evt.stopPropagation();
        this.handleDesignSelection(this.state.zoomDesign);
    }

    handlePrev = (evt: React.MouseEvent<HTMLDivElement>) =>{
        evt.stopPropagation();
        var curIndex = this.state.zoomDesign.displayIndex-1;
        curIndex = curIndex < 0 ? this.state.Designs.length - 1 : curIndex;
        this.setState({zoomDesign: this.state.Designs[curIndex]});
    }

    handleNext = (evt: React.MouseEvent<HTMLDivElement>) => {
        evt.stopPropagation();
        var curIndex = this.state.zoomDesign.displayIndex+1;
        curIndex = curIndex >= this.state.Designs.length ? 0 : curIndex;
        this.setState({zoomDesign: this.state.Designs[curIndex]});
    }
}

const mapStateToProps = (state : GlobalState, ownState: any) => {
    return { state: state  }
};

export var Collection = connect(mapStateToProps)(Radium(_Collection));